module.exports = __webpack_public_path__ + "img/ico_home.1e9aea5b.svg";